<div id="{{id}}">
    <field-item item="criteriaFormModel">
        <field-switch
                name="switch"
                label="{{label}}"
        ></field-switch>
    </field-item>
</div>
